import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Link } from 'react-router-dom';
export default function IconAvatars() {
    return (
        <Stack direction="column" spacing={2} position="absolute" sx={{
            zIndex: "9999",
            left: "20px",
            top: '10px',
            bottom: '10px'
        }}>
            <Link
                to="https://whas.me/pEXYB3mg3Z"
                target='_blank'
                style={{
                    color: "inherit",
                    textDecoration: "none",
                    fontSize: '2.5rem',
                    fontWeight: "bold",
                }}>
                <Avatar sx={{ width: "50px", height: "50px", backgroundColor: "#25D366" }} >
                    <WhatsAppIcon sx={{ fontSize: '2.5rem' }} />
                </Avatar>
            </Link>
            <Link
                to="tel:+97431555067"
                style={{
                    color: "inherit",
                    textDecoration: "none",
                    fontSize: '2.5rem',
                    fontWeight: "bold",
                }}>
                <Avatar sx={{ width: "50px", height: "50px", backgroundColor: "green" }} >
                    <LocalPhoneIcon sx={{ fontSize: '2.5rem' }} />
                </Avatar>
            </Link>
        </Stack>
    );
}